import styled, { css } from "styled-components";

export const ChipImage = styled.div`
  display: block;
  height: 100%;
  position: absolute;
  transform-origin: center;
  transition: transform 1s ease-in-out;
  width: 100%;
  z-index: 1;

  > img {
    height: 100%;
    object-fit: cover;
    object-position: center left;
    width: 100%;
  }
`;

export const ChipsWithImageContainer = styled.div<{ club?: boolean }>`
  border-radius: 4px;
  color: #160829;
  display: flex;
  font-size: 0;
  height: 120px;
  margin-bottom: 16px;
  overflow: hidden;
  position: relative;
  transition: box-shadow 0.25s ease;
  width: 100%;
  z-index: 1;

  h3 {
    align-self: flex-end;
    border-radius: 0 16px 16px 0;
    display: block;
    font-size: 16px;
    font-weight: 400;
    justify-self: flex-start;
    line-height: 22px;
    padding: 3px 10px 3px 8px;
    width: fit-content;
    z-index: 2;
    margin: 0;
  }

  ${({ club }) => css`
    h3 {
      background: ${club ? "#d518ff" : "#eeebf2"};
      color: ${club ? "#fff" : "#000"};
    }
  `}

  &:hover {
    box-shadow: 0 4px 8px 0 rgba(22, 8, 41, 0.3);

    ${ChipImage} {
      transform: scale(1.05);
    }
  }
`;
